import { useLoadUnits } from './useLoadUnits';
import { useLoadUserData } from './useLoadUserData';

/**
 * Custom hook for loading all necessary data into the Redux state.
 *
 * This hook combines various data loading functions from other custom hooks
 * to provide a single, comprehensive data loading solution. It loads user data,
 * units data, profile picture, custom fields, and handles passed master data.
 *
 * @returns {Object} An object containing the loadData function.
 */
export const useLoadData = () => {
  const { loadUserData } = useLoadUserData();
  const { loadUnits } = useLoadUnits();

  /**
   * Loads all data that should be in Redux state.
   * This function calls all the individual data loading functions
   * to populate the Redux store with necessary data.
   */
  const loadData = () => {
    loadUserData();
    loadUnits();
  };

  return {
    loadData,
  };
};
